export enum ResidentFamilyMemberStatus {
  PendingInvitation = 'Pending invitation',
  Verified = 'Verified',
}
